import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import CyberPortfolio from "./components/cyber/CyberPortfolio";
import SignalLost from "./components/cyber/SignalLost";
import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<CyberPortfolio />} />
        <Route path="*" element={<SignalLost />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
